import React, { Component } from 'react';
import PropTypes from 'prop-types';

import KioskCardReader from './KioskCardReader'

class StripeEmv extends Component<Props> {
    render() {
        return(
            <KioskCardReader loading={this.props.loading} error={this.props.error} total={this.props.total}/>
        )
    }
}

StripeEmv.propTypes = {
    loading: PropTypes.any,
    error: PropTypes.string,
};

export default StripeEmv;
